export default {
  // 按模板导出付款申请单 PDF。
  exportPaymentApplicationPdf: '/ygsjzs/yxcUserDepositNew/exportPaymentApplicationPdf',
  // 新增充值退还记录
  insertYxcUserDepositRecord: '/ygsjzs/yxcUserDepositRecord/insertYxcUserDepositRecord',
  insertYxcUserJrRecord: '/ygsjzs/yxcUserDepositRecord/insertYxcUserJrRecord',
  // 审批充值退还记录
  approvaYxcUserDepositRecord: '/ygsjzs/yxcUserDepositRecord/approvaYxcUserDepositRecord',
  // 物理删除充值退还记录
  deleteDataYxcUserDepositRecord: '/ygsjzs/yxcUserDepositRecord/deleteDataYxcUserDepositRecord',

  // 查询充值退还记录详情
  selectYxcUserDepositRecordByDepositId: '/ygsjzs/yxcUserDepositRecord/selectYxcUserDepositRecordByDepositId',
  // 分页查询充值退还记录列表
  selectYxcUserDepositRecordByPage: '/ygsjzs/yxcUserDepositRecord/selectYxcUserDepositRecordByPage',

  // 货款的充值
  insertYxcUserGoodsRecord: '/ygsjzs/yxcUserGoodsRecord/insertYxcUserGoodsRecord',
  approvaYxcUserGoodsRecord: '/ygsjzs/yxcUserGoodsRecord/approvaYxcUserGoodsRecord',
  deleteDataYxcUserGoodsRecord: '/ygsjzs/yxcUserGoodsRecord/deleteDataYxcUserGoodsRecord',
  selectYxcUserGoodsRecordByGoodsId: '/ygsjzs/yxcUserGoodsRecord/selectYxcUserGoodsRecordByGoodsId',
  selectYxcUserGoodsRecordByPage: '/ygsjzs/yxcUserGoodsRecord/selectYxcUserGoodsRecordByPage',
  // 快捷充值
  insertYxcUserAllDepositRecord: '/ygsjzs/yxcUserDepositRecord/insertYxcUserAllDepositRecord',

  // 新版充值管理
  insertYxcUserDepositNew: '/ygsjzs/yxcUserDepositNew/insertYxcUserDepositNew',
  updateYxcUserDepositNew: '/ygsjzs/yxcUserDepositNew/updateYxcUserDepositNew',
  approvaYxcUserDepositNew: '/ygsjzs/yxcUserDepositNew/approvaYxcUserDepositNew',
  deleteDataYxcUserDepositNew: '/ygsjzs/yxcUserDepositNew/deleteDataYxcUserDepositNew',
  selectYxcUserDepositNewByDepositId: '/ygsjzs/yxcUserDepositNew/selectYxcUserDepositNewByDepositId',
  selectYxcUserDepositNewByList: '/ygsjzs/yxcUserDepositNew/selectYxcUserDepositNewByList',
  txYxcUserDepositNewToPdf: '/ygsjzs/yxcUserDepositNew/txUserDepositNewToPdf',

  exportYxcDepositNew: '/ygsjzs/yxcUserDepositNew/exportYxcDepositNew'
}
